import { ROUTES } from '../../app/routes';
import catalog from './productCatalog.json';

/**
 * The Biznesi product line (`productCatalog.json`, shared with `scripts/seo-prerender.mjs`).
 * Every text lives in the locale files under `hub.products.items.<key>`; the catalogue only
 * holds what is not language: slug, product code, icon, directory group and website.
 */
export interface CatalogProduct {
  slug: string;
  key: string;
  code: string;
  status: 'live' | 'soon';
  icon: string;
  /** Directory group the product's businesses are listed under (`/c/:code`). */
  category?: string;
  /** The product's own customer website; overridden per environment below. */
  siteUrl?: string;
  /** A Hub page that lists this product's items instead of a directory group. */
  browsePath?: string;
}

export const PRODUCTS = catalog as CatalogProduct[];

/** Directory groups linked from the footer on every public page (`directory.Categories` group codes). */
export const FOOTER_CATEGORIES = ['FOOD_DRINK', 'BEAUTY', 'STAY', 'HEALTH', 'AUTO'] as const;

const SITE_OVERRIDES: Record<string, string | undefined> = {
  RESTAURANT: import.meta.env.VITE_RESTAURANT_APP_URL,
  COSMETICS: import.meta.env.VITE_COSMETICS_APP_URL,
};

export function productPath(slug: string) {
  return ROUTES.product.replace(':product', slug);
}

export function productSite(product: CatalogProduct) {
  return (SITE_OVERRIDES[product.code] || product.siteUrl)?.replace(/\/+$/, '');
}

export function productBrowsePath(product: CatalogProduct) {
  if (product.browsePath) return product.browsePath;
  return product.category ? ROUTES.category.replace(':categoryCode', product.category.toLowerCase()) : null;
}
